export const AllLoanRequestsReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_ALL_LOAN_REQUESTS_REQUEST":
      return { loading: true };
    case "GET_ALL_LOAN_REQUESTS_SUCCESS":
      return {
        ...state,
        loading: false,
        loans: action.payload.loans,
        loanCount: action.payload.loanCount,
      };
    case "GET_ALL_LOAN_REQUESTS_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null };
    default:
      return state;
  }
};

export const CurrentUserLoanRequestsReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_CURRENT_USER_LOAN_REQUESTS_REQUEST":
      return { loading: true };
    case "GET_CURRENT_USER_LOAN_REQUESTS_SUCCESS":
      return {
        ...state,
        loading: false,
        loans: action.payload.loans,
        loanCount: action.payload.loanCount,
      };
    case "GET_CURRENT_USER_LOAN_REQUESTS_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null };
    default:
      return state;
  }
};

export const CreateLoanRequestReducer = (state = { loan: {} }, action) => {
  switch (action.type) {
    case "CREATE_LOAN_REQUEST_REQUEST":
      return { loading: true, error: null, success: false };
    case "CREATE_LOAN_REQUEST_SUCCESS":
      return {
        loading: false,
        success: action.payload.success,
        loan: action.payload,
      };
    case "CREATE_LOAN_REQUEST_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "CREATE_LOAN_REQUEST_RESET":
      return { ...state, success: false };
    case "CLEAR_ERRORS":
      return { error: null };
    default:
      return state;
  }
};

export const IndivisualLoanRequestDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case "INDIVISUAL_LOAN_REQUEST_DETAIL_REQUEST":
      return { ...state, loading: true, error: null };
    case "INDIVISUAL_LOAN_REQUEST_DETAIL_SUCCESS":
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        loan: action.payload.loan,
      };
    case "INDIVISUAL_LOAN_REQUEST_DETAIL_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null };
    default:
      return state;
  }
};

export const LoanRequestDeleteReducer = (state = [], action) => {
  switch (action.type) {
    case "INDIVISUAL_LOAN_REQUEST_DELETE_REQUEST":
      return { ...state, loading: true };
    case "INDIVISUAL_LOAN_REQUEST_DELETE_SUCCESS":
      return { ...state, loading: false, deleted: action.payload };
    case "INDIVISUAL_LOAN_REQUEST_DELETE_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "INDIVISUAL_LOAN_REQUEST_DELETE_RESET":
      return { ...state, deleted: {} };
    case "CLEAR_ERRORS":
      return { ...state, error: null };
    default:
      return state;
  }
};
